export const dateFormatSeparatorOptions = [".", "-", "/"] as const
export type DateFormatSeparatorOptionType = (typeof dateFormatSeparatorOptions)[number]

export const dateFormatOptions = ["DD.MM.YYYY", "MM.DD.YYYY", "YYYY.MM.DD"] as const
export type DateFormatOptionType = (typeof dateFormatOptions)[number]
